module.exports = __webpack_public_path__ + "d2f45c2a64ee7a4583d8723e4b9a419f.pdf";